// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1g_sK","header":"PatientBlock_header__RO4hV","label":"PatientBlock_label__Ztzw6","option":"PatientBlock_option__3drna"};